import {UseUrlHookOptionsDefinedType} from './url-hook-type';

export const urlHookDefaultOptions: UseUrlHookOptionsDefinedType = {
    isSaveQuery: false,
    isSaveHash: false,
};
